import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import FlightTab from "./flightTab";
import HotelTab from "./hotelTab";
import {  BsTicketDetailed } from "react-icons/bs";
import EditMyTicketTab from "./editMyTicketTab";

const SearchForm = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();

    const getActiveTab = () => {
        if (location.pathname.includes("flight-search")) return "flight";
        if (location.pathname.includes("hotel-search")) return "hotel";

        const searchParams = new URLSearchParams(location.search);
        return searchParams.get("tab") || "flight";
    };

    const activeTab = getActiveTab();

    const handleTabClick = (tabName) => {
        if (tabName === "flight" && location.pathname.includes("flight-search"))
            return;
        if (tabName === "hotel" && location.pathname.includes("hotel-search"))
            return;
        navigate(`/?tab=${tabName}`);
    };

    return (
        <section
            id={
                location.pathname.includes("search")
                    ? "theme_search_form1"
                    : "theme_search_form2"
            }
        >
            <div className="container mx-auto max-w-[1440px] px-3">
                <div className="theme_search_form_area">
                    <div className="theme_search_form_tabbtn">
                        <ul className="nav nav-tabs" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button
                                    className={`nav-link ${
                                        activeTab === "flight" ? "active" : ""
                                    }`}
                                    onClick={() => handleTabClick("flight")}
                                    role="tab"
                                    aria-selected={activeTab === "flight"}
                                >
                                    <i className="fas fa-plane-departure mr-2"></i>
                                    {t("flight")}
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className={`nav-link ${
                                        activeTab === "hotel" ? "active" : ""
                                    }`}
                                    onClick={() => handleTabClick("hotel")}
                                    role="tab"
                                    aria-selected={activeTab === "hotel"}
                                >
                                    <i className="fas fa-hotel mr-2"></i>
                                    {t("hotel")}
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className={`nav-link flex items-center gap-2 ${
                                        activeTab === "editMyTicket" ? "active" : ""
                                    }`}
                                    onClick={() => handleTabClick("editMyTicket")}
                                    role="tab"
                                    aria-selected={activeTab === "editMyTicket"}
                                >
                                    <BsTicketDetailed  />
                                    {t("modifyMyTicket")}
                                </button>
                            </li>
                        </ul>
                    </div>

                    <div className="tab-content">
                        <div
                            className={`tab-pane ${
                                activeTab === "flight" ? "show active" : ""
                            }`}
                            role="tabpanel"
                        >
                            {activeTab === "flight" && <FlightTab />}
                        </div>
                        <div
                            className={`tab-pane ${
                                activeTab === "hotel" ? "show active" : ""
                            }`}
                            role="tabpanel"
                        >
                            {activeTab === "hotel" && <HotelTab />}
                        </div>
                        
                        <div 
                            className={`tab-pane ${
                                activeTab === "editMyTicket" ? "show active" : ""
                            }`}
                            role="tabpanel"
                        >
                            {activeTab === "editMyTicket" && (
                                <EditMyTicketTab/>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default SearchForm;
